import { render, staticRenderFns } from "./LoginSuccess.vue?vue&type=template&id=386d9d10"
import script from "./LoginSuccess.js?vue&type=script&lang=js&external"
export * from "./LoginSuccess.js?vue&type=script&lang=js&external"
import style0 from "./LoginSuccess.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports